import { jsx as _jsx } from "react/jsx-runtime";
import { Button as MuiButton, useTheme } from '@mui/material';
const Button = ({ children, variant = 'primary', size = 'medium', onClick, disabled = false, startIcon, endIcon, className, sx }) => {
    const theme = useTheme();
    const getVariantStyles = () => {
        switch (variant) {
            case 'primary':
                return {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.common.white,
                    border: 'none',
                    '&:hover': {
                        backgroundColor: theme.palette.primary.dark
                    }
                };
            case 'secondary':
                return {
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.common.white,
                    border: 'none',
                    '&:hover': {
                        backgroundColor: theme.palette.secondary.dark
                    }
                };
            case 'outlined':
                return {
                    backgroundColor: 'transparent',
                    color: theme.palette.primary.darker,
                    border: `1px solid ${theme.palette.primary.darker}`,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.common.white
                    }
                };
            case 'text':
                return {
                    backgroundColor: 'transparent',
                    color: theme.palette.text.primary,
                    border: 'none',
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                };
            default:
                return {};
        }
    };
    const getSizeStyles = () => {
        switch (size) {
            case 'small':
                return {
                    padding: theme.spacing(0.5, 1.5),
                    fontSize: '12px',
                    minHeight: 28
                };
            case 'medium':
                return {
                    padding: theme.spacing(0.75, 2),
                    fontSize: '14px',
                    minHeight: 32
                };
            case 'large':
                return {
                    padding: theme.spacing(1, 2.5),
                    fontSize: '16px',
                    minHeight: 40
                };
            default:
                return {};
        }
    };
    return (_jsx(MuiButton, { className: className, onClick: onClick, disabled: disabled, startIcon: startIcon, endIcon: endIcon, sx: {
            borderRadius: theme.spacing(1),
            textTransform: 'none',
            fontWeight: 500,
            boxShadow: 'none',
            ...getVariantStyles(),
            ...getSizeStyles(),
            '&:hover': {
                boxShadow: 'none',
                ...getVariantStyles()['&:hover']
            },
            '&:disabled': {
                backgroundColor: theme.palette.action.disabled,
                color: theme.palette.action.disabled,
                border: 'none'
            },
            ...sx
        }, children: children }));
};
export default Button;
